import React from "react";

const Benefit = ({ icon, title, detail }) => {
  return (
    <div className="flex flex-column justify-content-start align-items-center text-center w-full sm:w-18rem">
      <div className="benefitIcon">{icon}</div>
      <h3 className="benefitTitle">{title}</h3>
      <div className="benefitText">{detail}</div>
    </div>
  );
};

export default Benefit;
